<!-- src/App.vue -->
<template>
  <div id="app">
    <LoadingIndicator />
    <RouterView />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import MainLayout from './components/MainLayout.vue';
import LoadingIndicator from './components/LoadingIndicator.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

@Options({
  components: {
    MainLayout,
    LoadingIndicator,
  },
})
export default class App extends Vue {}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}
</style>
